import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";

class TemplateLight {
    public Id: string;
    public Name: string;
    public SiteId?: string;

    public static toComboboxItem(template: TemplateLight): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(template.Id, template.Name, 0);
    }

    public static toComboboxItemWithSiteId(template: TemplateLight, siteName: string): ComboBoxDropDownItem {
        const site = siteName ?? "";

        return !!site ? new ComboBoxDropDownItem(template.Id, `${site} - ${template.Name}`, 0) :
            new ComboBoxDropDownItem(template.Id, template.Name, 0);
    }
}

export { TemplateLight };
